import { QuoteIcon, TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';

import MobileFeature from './MobileFeature';

const StartDay = (): JSX.Element => {
  const t = useTranslations();
  return (
    <MobileFeature
      title="features_tab_1_label"
      image={{
        alt: 'tab_item_start_day_img_aria_label',
        src: 'blue-sky/home/start-day',
      }}
    >
      <div className="relative mt-14 hidden lg:block" data-cy="start-day">
        <Image
          alt={t('tab_item_start_day_img_aria_label')}
          src="blue-sky/home/start-day"
          width={520}
          height={520}
          className="rounded-lg object-cover"
        />
      </div>
      <div
        className={cx(
          'absolute bottom-16 left-1/2 w-[80vw] max-w-[300px] -translate-x-1/2 flex-col gap-y-6',
          'lg:relative lg:bottom-auto lg:left-0 lg:flex lg:w-auto lg:max-w-none lg:translate-x-0',
        )}
      >
        <div className="hidden grid-cols-1 grid-rows-1 lg:grid">
          <Image
            alt=""
            className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
            src="blue-sky/home/start-day-mask-1"
            width={300}
            height={265}
          />
          <Image
            alt={t('sleep_app_image_alt')}
            className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
            src={t('time_asleep_app_ui')}
            format="png"
            width={300}
            height={265}
          />
        </div>
        <div className="hidden grid-cols-1 grid-rows-1 lg:grid">
          <Image
            alt=""
            className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
            src="blue-sky/home/start-day-mask-2"
            width={300}
            height={270}
          />
          <Image
            alt={t('readiness_app_image_alt')}
            className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
            src={t('readiness_app_ui')}
            format="png"
            width={300}
            height={270}
          />
        </div>
        <Motion
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, type: 'tween', delay: 0.5 }}
          className="grid grid-cols-1 grid-rows-1 lg:hidden"
        >
          <Image
            alt=""
            className="col-start-1 col-end-2 row-start-1 row-end-2 h-full rounded-lg"
            src="blue-sky/home/start-day-mask-mobile"
            width={300}
            height={277}
          />
          <Image
            alt={t('readiness_app_image_alt')}
            className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
            src={t('readiness_app_ui')}
            format="png"
            width={300}
            height={277}
          />
        </Motion>
      </div>
      <div className="hidden self-center rounded-lg border border-gray-300 px-10 py-12 lg:block">
        <QuoteIcon className="text-olive-700" />
        <TypographyV3 className="mt-10 text-3xl" font="serif" variant="unset">
          {t.rich('features_tab_1_quote')}
        </TypographyV3>
        <TypographyV3
          className="mt-4 text-olive-700"
          variant="body-small"
          color="unset"
        >
          Jussi L., {t('oura_member')}
        </TypographyV3>
      </div>
    </MobileFeature>
  );
};

export default StartDay;
